<template>
  <div class="demoback">
    <div class="demoboard">
      <h1>Authenticate</h1>
      <p>Google stuff</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Google",
};
</script>

<style scoped>
.demoback {
  background-color: #f0f0f0;
  height: 100%;
  width: 100%;
  position: absolute;
  overflow-y: scroll;
  display: flex;
  justify-content: center;
}
.demoboard {
  text-align: center;
  padding: 20px;
  background: white;
  width: 1200px;
  margin: 10px;
  height: fit-content;
}
</style>
